var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtgrBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 6.64689V4.81356C7.33333 4.32733 7.52649 3.86101 7.8703 3.5172C8.21412 3.17338 8.68044 2.98022 9.16667 2.98022H12.8333C13.3196 2.98022 13.7859 3.17338 14.1297 3.5172C14.4735 3.86101 14.6667 4.32733 14.6667 4.81356V6.64689M2.75 8.48022C2.75 7.99399 2.94315 7.52768 3.28697 7.18386C3.63079 6.84005 4.0971 6.64689 4.58333 6.64689H17.4167C17.9029 6.64689 18.3692 6.84005 18.713 7.18386C19.0568 7.52768 19.25 7.99399 19.25 8.48022V16.7302C19.25 17.2165 19.0568 17.6828 18.713 18.0266C18.3692 18.3704 17.9029 18.5636 17.4167 18.5636H4.58333C4.0971 18.5636 3.63079 18.3704 3.28697 18.0266C2.94315 17.6828 2.75 17.2165 2.75 16.7302V8.48022Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtgrBusiness);
export default __webpack_public_path__ + "static/media/ctgr-business.359d2ed9acebd158ba39181c211e0f27.svg";
export { ForwardRef as ReactComponent };